module.exports = __webpack_public_path__ + "img/yy-s5.388514d2.svg";